import { RoomStateStatus } from '../models/RoomState'
import type {
  RoomStateWithStatus,
  RoomStateWithStatusAndRoleIssue,
} from '../types'

function sortOrder(status: RoomStateStatus) {
  switch (status) {
    case RoomStateStatus.live:
      return 0
    case RoomStateStatus.suspended:
    case RoomStateStatus.mustScheduleSuspended:
      return 1
    case RoomStateStatus.scheduled:
      return 2
    case RoomStateStatus.mustSchedule:
      return 3
    case RoomStateStatus.completed:
      return 4
    case RoomStateStatus.queuedForGrading:
      return 5
    case RoomStateStatus.expired:
      return 6
    case RoomStateStatus.canceled:
      return 7
    case RoomStateStatus.abandoned:
      return 8
  }
}

export function sortRoomStatesWithStatus<
  T extends RoomStateWithStatusAndRoleIssue[] | RoomStateWithStatus[],
>(rooms: T): T {
  return rooms.sort((a, b) => {
    const aRoleIssue = 'roleIssue' in a ? a.roleIssue : null
    const bRoleIssue = 'roleIssue' in b ? b.roleIssue : null

    // sort rooms with role issues first
    if (aRoleIssue && !bRoleIssue) return -1
    if (!aRoleIssue && bRoleIssue) return 1

    const aOrder = sortOrder(a.status)
    const bOrder = sortOrder(b.status)
    if (aOrder !== bOrder) return aOrder - bOrder

    const aTime = a.data.scheduledAt?.getTime()
    const bTime = b.data.scheduledAt?.getTime()

    if (aTime && !bTime) return -1
    if (!aTime && bTime) return 1
    if (aTime && bTime && aTime !== bTime) return aTime - bTime

    if (!a.data.roomStateName) return 1
    if (!b.data.roomStateName) return -1

    const aName = a.simpleRoomName
    const bName = b.simpleRoomName
    return aName.localeCompare(bName)
  }) as T
}
